import React, { useState, useEffect } from 'react'; // Import hooks only once

import Layout from "../components/layout";
import Footer from '../components/footer';
import BgImage from '../images/bg/pragicts-featured-projects.jpg';
import empl from '../images/projects/empl.png';
import mybiz from '../images/projects/mybiz.png';
import pragicts from '../images/projects/pragicts.png';
import softwaredevelopment from '../images/projects/softwaredevelopment.png';
import itops from '../images/projects/itops.png';
import cloudops from '../images/projects/cloudops.png';
import cybersecops from '../images/projects/cyber.png';
import SocialIconsFooter from '../components/social-icons-footer';
import automation from '../images/projects/auto.png';
import digitaloutreach from '../images/projects/digitaloutreach.png';
import ecommerce from '../images/projects/ecommerce.png';
import sentinel from '../images/projects/sentinel.png';
import pay from '../images/projects/pay.png';
import smiley from '../images/projects/smiley.png';
import ai from '../images/projects/ai.png';
import pulse from '../images/projects/pulse.png';
import octagon from '../images/projects/octagon-equipment.png';
import cognizant from '../images/projects/cognizant.png';
import puro from '../images/projects/puro-img.png';
import virtue from '../images/projects/virtue.png';
import rigor from '../images/projects/rigor.png';
import agc from '../images/projects/agcsite.png';
import techno from '../images/projects/techno.png';
import lushsc from '../images/projects/lushsc.png';
import ayana from '../images/projects/ayana.png';
import alphaandomegalk from '../images/projects/alphaandomegalk.png';
import meditechnology from '../images/projects/meditechnology.png';
import nextgen from '../images/projects/nextgen.png';
import sleep from '../images/projects/sleep.png';
import ptt from '../images/projects/ptt.png';
import zenith from '../images/projects/zenith.png';
import biophilia from '../images/projects/biophilia.png';
import flareup from '../images/projects/flareup-site.png';
import shanteas from '../images/projects/shanteas.png';
import unicorn from '../images/projects/unicorn-site.png';
import senehasa from '../images/projects/senahasa.png';
import toolshub from '../images/projects/toolshub.png';
import adylet from '../images/projects/adylet.png';
import praguna from '../images/projects/praguna.png';
import windy from '../images/projects/windyhillsbungalow.png';
import innotech from '../images/projects/innotech.png';
import agc2 from '../images/projects/agc2.png';
import biophilia_shop from '../images/projects/biophilia_shop.png';
import toolshub_shop from '../images/projects/toolshub_shop.png';
import cpp from '../images/projects/cpp.jpg';
import auth from '../images/projects/auth.jpg';

import html from '../images/stack_logo/html.png';
import css from '../images/stack_logo/css.png';
import aws from '../images/stack_logo/aws.png';
import cloudfront from '../images/stack_logo/cloudfront.png';
import docs from '../images/stack_logo/docs.png';
import ec2 from '../images/stack_logo/ec2.png';
import google from '../images/stack_logo/google.png';
import js from '../images/stack_logo/js.png';
import og from '../images/stack_logo/og.png';
import bootstrap from '../images/stack_logo/bootstrap.png';
import php from '../images/stack_logo/php.png';
import cybersource from '../images/stack_logo/cybersource.png';
import mysql from '../images/stack_logo/mysql.png';
import bagisto from '../images/stack_logo/bagisto.png';
import redis from '../images/stack_logo/redis.png';
import opencart from '../images/stack_logo/opencart.png';
import ansible from '../images/stack_logo/ansible.png';
import veeam from '../images/stack_logo/veeam.png';
import terraform from '../images/stack_logo/terraform.png';
import puppet from '../images/stack_logo/puppet.png';
import jenkins from '../images/stack_logo/jenkins.png';
import gitlab from '../images/stack_logo/gitlab.png';
import github from '../images/stack_logo/github.png';
import grafana from '../images/stack_logo/grafana.png';
import prometheus from '../images/stack_logo/prometheus.png';
import pagerduty from '../images/stack_logo/pagerduty.png';
import tenable from '../images/stack_logo/tenable.png';
import azure from '../images/stack_logo/azure-logo.png';
import fortinet from '../images/stack_logo/fortinet-logo.png';
import pragictslogo from '../images/stack_logo/pragicts.png';
import bitdefender from '../images/stack_logo/bitdefender_logo.png';
import paloalto from '../images/stack_logo/paloalto.png';
import dell from '../images/stack_logo/dell.png';
import microsoft from '../images/stack_logo/microsoft.png';
import checkpoint from '../images/stack_logo/checkpoint.png';
import extreme from '../images/stack_logo/extreme.png';
import hp from '../images/stack_logo/hp.png';
import cloudflare from '../images/stack_logo/cloudflare.png';

import abb from '../images/stack_logo/abb.png';
import workspace from '../images/stack_logo/workspace.png';

const projects = [
  { id: 1, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    sub_category: "Online Presence Implementation (Website Development)", 
    image: empl , 
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"EMPL",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
   

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
   

    engineering:'HTML framework based website development with Google Doc Integration for the tracking platform',
    online_reference:'https://empl.lk/'},
  { id: 2, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: mybiz, sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"myBIZ",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://mybizsl.lk/'},
  { id: 3, 
    title: "Online presence implementation including website design and development for the corporate website of PragICTS. The root website of the company.", 
    category: "software", 
    image: pragicts, sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://pragicts.com'},
 
 
    { id: 4, 
    title: "Online presence implementation including website design and development for the Software Development vertical of PragICTS.", 
    category: "software", 
    image: softwaredevelopment, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://softwaredevelopment.pragicts.com/'
  },
  { id: 5, title: "Online presence implementation including website design and development for the ITOps vertical of PragICTS.", 
    category: "software", 
    image: itops, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://itops.pragicts.com/'
  },
  { id: 6, 
    title: "Online presence implementation including website design and development for the CloudOps vertical of PragICTS.", 
    category: "software", 
    image: cloudops, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://cloudops.pragicts.com'
  },
  { id: 7, 
    title: "Online presence implementation including website design and development for the Cybersecurity vertical of PragICTS.", 
    category: "software", 
    image: cybersecops, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://cybersecops.pragicts.com'
  },
  { id: 8, 
    title: "Online presence implementation including website design and development for ITOps Automation vertical of PragICTS. ", 
    category: "software", 
    image: automation, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://automation.pragicts.com'
  },
  { id: 9, 
    title: "Online presence implementation including website design and development for the Digital Outreach vertical of PragICTS.", 
    category: "software", 
    image: digitaloutreach, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://digitaloutreach.pragicts.com'
  },
  { id: 10, 
    title: "Online presence implementation including website design and development for the eCommerce vertical of PragICTS.", 
    category: "software", 
    image: ecommerce, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
       technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
  
    

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://ecommerce.pragicts.com'
  },
  { id: 11, 
    title: "Online presence implementation including website design and development for the Sentinel Platform of PragICTS.", 
    category: "software", 
    image: sentinel, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://sentinel.pragicts.com'
  },
  { id: 12, 
    title: "Online presence implementation including website design and development for the Pay Platform of PragICTS.", 
    category: "software", 
    image: pay, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://pay.pragicts.com'
  },
  { id: 13, 
    title: "Online presence implementation including website design and development for the AI vertical of PragICTS", 
    category: "software", 
    image: ai, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://ai.pragicts.com'
  },
  { id: 14, 
    title: "Online presence implementation including website design and development for the Smiley Platform of PragICTS.", 
    category: "software", 
    image: smiley, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://smiley.pragicts.com'
  },
  { id: 15, 
    title: "Online presence implementation including website design and development for the Pulse Platform of PragICTS.", 
    category: "software", 
    image: pulse, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development with Gatsby',
    online_reference:'https://pulse.pragicts.com'
  },
  { id: 16, 
    title: "Online presence implementation including website design and development for the Cognizant Platform of PragICTS", 
    category: "software", 
    image: cognizant, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"PragICTS",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://cognizant.pragicts.com'
  },
  { id: 17, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: octagon, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Octagon Equipment",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://octagon-equipment.com'
  },
  { id: 18, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: puro, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Puro",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://puro.lk/'
  },
  { id: 19, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: virtue, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Virtue Value Engineering",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://virtue.lk/'
  },
  { id: 20, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: rigor, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Rigor Consulting",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://rigor.consulting/'
  },
  { id: 21, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: cpp, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Colombo Picture Palace",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://cppglass.com/'
  },
  { id: 22, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: agc, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Asian Group of Companies",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://agc.lk'
  },
  { id: 23, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: techno, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Technomedics Group",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://technomediclk.com/'
  },
  { id: 24, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: lushsc, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Lush Skin Clinic",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://lushsc.com/'
  },
  { id: 25, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: ayana, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Ayana Villas and Resorts",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://ayanavillasandresorts.com/'
  },
  { id: 26, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: alphaandomegalk, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Alpha and Omaga",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://alphaandomegalk.com/'
  },
  { id: 27, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: meditechnology, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Meditechnology",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://meditechnologylk.com/'
  },
  { id: 28, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: nextgen, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"NextGen",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://www.nextgenhclk.com/'
  },
  { id: 29, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: sleep, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Sleep",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://www.dreamsleeplk.com/'
  },
  { id: 30, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: ptt, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"P&T",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://ptt.lk/'
  },
  { id: 31, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: zenith, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Zenith Impex",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
 
    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    engineering:'HTML framework based website development',
    online_reference:'https://www.zenithlk.com/'
  },
  { id: 32, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: biophilia, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Biophilia",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:bootstrap,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"bootstrap",
   

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://getbootstrap.com/",
    engineering:'Hand coded from ground up using the Bootstrap framework ( https://getbootstrap.com/ ) ',
    online_reference:'https://biophilia.lk'
  },
  { id: 33, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: flareup, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Flareup Digital",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://flareup.digital'
  },
  { id: 34, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: "", 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Siyol",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,


    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
   

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://siyol.com'
  },
  { id: 35, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: shanteas, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Shan Teas",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
  
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://shanteas.com'
  },
  { id: 36, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: senehasa, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Senehasa",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
 
    engineering:'HTML framework based website development.',
    online_reference:''
  },
  { id: 37, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: unicorn, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Unicorn Metalics",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
  
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
 
    engineering:'HTML framework based website development.',
    online_reference:'https://unicornmetalics.com/'
  },
  { id: 38, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: toolshub, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Tools Hub Industrial",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://industrial.toolshub.lk/'
  },
  { id: 39, 
    title: "Online advertising platform for Botswana", 
    category: "software", 
    image: adylet, 
    sub_category: "Online Convenience Platform (advertising Platforms)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Adylet",
    key_functions:"Design and Development, Initial Data Upload, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
 
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development with content management through headless content management platform ( https://strapi.io/ )',
    online_reference:'https://adylet.com/'
  },
  { id: 40, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: praguna, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Praguna Global",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
  
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://praguna-global.com/'
  },
  { id: 41, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: windy, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"Windy Hills Bungalow",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
  
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'http://windyhillsbungalow.com/'
  },
  { id: 42, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: innotech, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"InnoTech",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
  
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",

    engineering:'HTML framework based website development.',
    online_reference:'https://www.innotechlk.com/'
  },
  { id: 43, 
    title: "Online presence implementation including website design and development.", 
    category: "software", 
    image: agc2, 
    sub_category: "Online Presence Implementation (Website Development)",
    objectives: "Build and maintain an effective website that serves as a cornerstone in the digital space, providing enhanced visibility and a compelling proposition. This website will play a crucial role in positioning the company strategically online, helping to amplify business objectives and drive sustainable growth. By aligning with key business goals, the website will act as an effective platform on the digital space for attracting new customers, increasing engagement, and ultimately supporting long-term success.", 
    client:"AGC",
    key_functions:"Design and Development, Content Writing, Google Business Registration,  Google Analytics Integration, Open Graph Integration, Social Platform Integration, AWS Cloud Hosting, AWS Cloudfront Implementation ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:php,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"php",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.php.net/",

    engineering:'HTML framework based website development.',
    online_reference:'https://agc.lk'
  },
  { id: 44, 
    title: "Online invoicing and payment platform with integration with VISA Payment Gateway through local partner bank.", 
    category: "software", 
    image: auth, 
    sub_category: "Enterprise Applications",
    objectives: "Implement a secure (2FA + SSL) platform for online invoicing and payment for tour operators / destination management companies world wide.", 
    client:"Authenticities Sri Lanka",
    key_functions:"Scoping, Design, Development, Implementation, Management, Support and Productization",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:cybersource,
   
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"cybersource",


    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.cybersource.com/en-us/solutions/payment-acceptance/payment-gateway.html",

    engineering:'HTML framework based website development.',
    online_reference:'https://pay.authenticitiessrilanka.com/'
  },
  { id: 45, 
    title: "Online invoicing and payment platform with integration with VISA Payment Gateway through local partner bank.", 
    category: "software", 
    image: pay, 
    sub_category: "Enterprise Applications",
    objectives: "Implement a secure (2FA + SSL) platform for online invoicing and payment for tour operators / destination management companies world wide.", 
    client:"Ayana Villas and Resorts",
    key_functions:"Scoping, Design, Development, Implementation, Management, Support and Productization",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:cybersource,
    technology_stack7:php,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"cybersource",
    technology_name7:"php",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.cybersource.com/en-us/solutions/payment-acceptance/payment-gateway.html",
    technology_stack7_link:"https://www.php.net/",

    engineering:'HTML framework based website development.',
    online_reference:'https://pay.pragicts.com'
  },
  { id: 46, 
    title: "Deployment of a Sentiment Management Platform Smiley.", 
    category: "software", 
    image: smiley, 
    sub_category: "Enterprise Applications",
    objectives: "Assess customer feedback at the department store of AGC", 
    client:"AGC",
    key_functions:"Capture customer sentiments at billing counters to ensure a positive customer experience at the AGC department store in Colombo. ",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:mysql,
    technology_stack7:php,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"mysql",
    technology_name7:"php",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.mysql.com/ ",
    technology_stack7_link:"https://www.php.net/",

    engineering:'',
    online_reference:'https://smiley.pragicts.com'
  },
  { id: 47, 
    title: "Design and Implementation of a full fledge ecommerce place with multiple and staggered payment and delivery options.", 
    category: ['ecommerce', 'software'], 
    image: agc, 
    sub_category: "eCommerce",
    objectives: "AGC is a well-established brand renowned for its high-quality hardware products, with both wholesale and retail operations spanning across Sri Lanka. The company plans to broaden its reach by launching an e-commerce platform, leveraging the expanding digital marketplace to enhance customer service, capitalize on online commerce opportunities, and diversify its portfolio into the household and office sectors.", 
    client:"AGC",
    key_functions:"Design, Development, Support and Management including Cloud Hosting",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:bagisto,
    technology_stack7:redis,

    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"bagisto",
    technology_name7:"redis",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://bagisto.com/en/ ",
    technology_stack7_link:"https://redis.io/",

    engineering:'Implemented and customized on the Bagisto platform with Redis integration for data cashing on both upload and retrieval with AWS Proximity hosting in Singapore with auto scalability.',
    online_reference:'https://agc.lk'
  },
  { id: 48, 
    title: "Design and Implementation of a full fledge ecommerce place with multiple and staggered payment and delivery options.", 
    category: ['ecommerce', 'software'], 
    image: biophilia_shop, 
    sub_category: "eCommerce",
    objectives: "Biophilia is an emerging startup focused on creating an e-commerce platform dedicated to offering nature-friendly and sustainable products, tailored specifically for the Sri Lankan market. The company aims to promote environmentally-conscious consumer choices by providing a curated selection of products that align with sustainability and eco-friendly values.", 
    client:"Biophilia",
    key_functions:"Design, Development, Support and Management including Cloud Hosting",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:opencart,
 
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"opencart",
   

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.opencart.com/",


    engineering:'Implemented and customized on the Bagisto platform with AWS hosting.',
    online_reference:'https://shop.biophilia.lk'
  },
  { id: 49, 
    title: "Design and Implementation of a full fledge ecommerce place with multiple and staggered payment and delivery options.", 
    category: ['software', 'ecommerce'], 
    image: toolshub_shop, 
    sub_category: "eCommerce",
    objectives: "", 
    client:"ToolsHub",
    key_functions:"Design, Development, Support and Management including Cloud Hosting",
    technology_stack:html,
    technology_stack2:css,
    technology_stack3:js,
    technology_stack4:aws,
    technology_stack5:google,
    technology_stack6:opencart,
 
    technology_name:"html",
    technology_name2:"css",
    technology_name3:"js",
    technology_name4:"aws",
    technology_name5:"google",
    technology_name6:"opencart",

    technology_stack_link:"https://www.w3.org",
    technology_stack2_link:"https://www.w3.org",
    technology_stack3_link:"https://www.w3.org",
    technology_stack4_link:"https://aws.amazon.com/lightsail/",
    technology_stack5_link:"https://marketingplatform.google.com/about/analytics/",
    technology_stack6_link:"https://www.opencart.com/",


    engineering:'Implemented and customized on the Bagisto platform with AWS hosting.',
    online_reference:'https://shop.toolshub.lk'
  },
  { id: 50, 
    title: "The backup and recovery automation. Eliminate the human driven inconsistent and unreliable backup processes.", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Backup and Recovery Automation",
    objectives: "Progressively automate the manual, repetitive tasks that slow operations, error-prone configuration management, inefficient use of IT resources leading to increased costs, delays in deployments due to complex workflows, insufficient monitoring and incident response capabilities", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:veeam,
    technology_stack2:aws,
    technology_stack3:ansible,
   
    technology_name:"veeam",
    technology_name2:"aws",
    technology_name3:"ansible",
   

    technology_stack_link:"https://www.veeam.com/",
    technology_stack2_link:"https://aws.amazon.com/backup/",
    technology_stack3_link:"https://www.redhat.com/en/ansible-collaborative",


    engineering:'Programming (scripting) for the automation.',
    online_reference:''
  },
  { id: 51, 
    title: "Provisioning of cloud infrastructure", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Cloud Infrastructure Automation",
    objectives: "Enable rapid provisioning of cloud infrastructure.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:aws,
    technology_stack2:terraform,
    
    technology_name:"aws",
    technology_name2:"terraform",
 

    technology_stack_link:"https://aws.amazon.com/pm/ec2",
    technology_stack2_link:"https://www.terraform.io/",



    engineering:'Programming (scripting) for the automation.',
    online_reference:''
  },
  { id: 52, 
    title: "Configuration Management", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Infrastructure Automation",
    objectives: "Address the consistency of configuration management of infrastructure.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:ansible,
    technology_stack2:puppet,
    
    technology_name:"ansible",
    technology_name2:"puppet",
 

    technology_stack_link:"https://www.redhat.com/en/ansible-collaborative",
    technology_stack2_link:"https://www.puppet.com/",



    engineering:'Programming (scripting) for the automation.',
    online_reference:''
  },
  { id: 53, 
    title: "Continuous Integration/Continuous Deployment (CI/CD)", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "DevOps Automation",
    objectives: "Eliminate lengthy development cycles due to manual testing and deployment.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:jenkins,
    technology_stack2:gitlab,
    technology_stack3:github,
   
    technology_name:"jenkins",
    technology_name2:"gitlab",
    technology_name3:"github",

    technology_stack_link:"https://www.jenkins.io/",
    technology_stack2_link:"https://about.gitlab.com/",
    technology_stack3_link:"https://github.com/",


    engineering:'Programming (scripting) for the automation.',
    online_reference:''
  },
  { id: 54, 
    title: "Centralized and unified tracking for live management of the entire IT infrastructure.", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Unified Tracking",
    objectives: "Minimize downtime and enable preventive management.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:grafana,
    technology_stack2:prometheus,
    technology_stack3:pagerduty,
   
    technology_name:"grafana",
    technology_name2:"prometheus",
    technology_name3:"pagerduty",

    technology_stack_link:"https://grafana.com/",
    technology_stack2_link:"https://prometheus.io/",
    technology_stack3_link:"https://www.pagerduty.com/",


    engineering:'Programming of the said infrastructure for personalization and customization.',
    online_reference:''
  },
  { id: 55, 
    title: "Automation of configuration and management for consistency, rapid deployment and efficiency.", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Network Automation",
    objectives: "Enhance response time in network management", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:ansible,
    
    technology_name:"ansible",
   

    technology_stack_link:"https://docs.ansible.com/ansible/latest/network/index.html",
 


    engineering:'Programming of the said infrastructure.',
    online_reference:''
  },
  { id: 56, 
    title: "Automation of configuration and management for consistency, rapid deployment and efficiency.", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Security Automation",
    objectives: "Consistency and quality of securiy.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:tenable,
    technology_stack2:aws,
    technology_stack3:ansible,

    technology_name:"tenable",
    technology_name2:"aws",
    technology_name3:"ansible",
    
    technology_stack_link:"https://www.tenable.com/products/nessus",
    technology_stack2_link:"https://aws.amazon.com/config/",
    technology_stack3_link:"https://www.redhat.com/en/ansible-collaborative",


    engineering:'Programming of the said infrastructure.',
    online_reference:''
  },
  { id: 57, 
    title: "Automation of cloud and cross cloud functions.", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Hybrid / Multi Cloud Automation",
    objectives: "consistency and efficiency in cloud management across cloud platforms and services", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:google,
    technology_stack2:terraform,
  
    technology_name:"google",
    technology_name2:"terraform",
  

    technology_stack_link:"https://cloud.google.com/anthos",
    technology_stack2_link:"https://www.terraform.io",



    engineering:'Programming of the said infrastructure.',
    online_reference:''
  },
  { id: 58, 
    title: "Automation of cloud resourcing", 
    category: ['itops', 'automation'], 
    image: '', 
    sub_category: "Automation of Cost Optimization on Utilization",
    objectives: "Keeping cloud usage costs close to utilization", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied R&D, POC, Implementation, Management and Support.",
    technology_stack:aws,
    technology_stack2:azure,
  
    technology_name:"aws",
    technology_name2:"azure",
  

    technology_stack_link:"https://aws.amazon.com/",
    technology_stack2_link:"https://azure.microsoft.com/en-us/",



    engineering:'Programming of the said infrastructure.',
    online_reference:''
  },
  { id: 59, 
    title: "Secure all physical location of the client's IT infrastructure through the deployment firewall appliances across all locations with centralized cloud management", 
    category: ['itops', 'cyber'], 
    image: '', 
    sub_category: "Security",
    objectives: "Secure all IT Infrastructure across all locations of the client.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Procurement, Installation, Configuration (including policy definition and management), Management and Support of the firewall infrastructure.",
    technology_stack:fortinet,
 
  
    technology_name:"fortinet",

  

    technology_stack_link:"https://www.fortinet.com/",
   



    engineering:'Installation, setup including company wide firewall policy definition, management and support.',
    online_reference:''
  },
  { id: 60, 
    title: "Dedicated total onsite management of the entire IT infrastructure on behalf of the client.", 
    category: 'itops', 
    image: '', 
    sub_category: "Operations and Management",
    objectives: "Total management of the entire IT infrastructure to relieve the client to focus on the business.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Total management and administration",

    technology_stack:pragictslogo,
 
  
    technology_name:"Technology Stacks pertaining to ITOps, CloudOps, Automation, Unified Management, SecOps, etc.",

  

    technology_stack_link:"#",
   



    engineering:'Total Management including procurement',
    online_reference:''
  },
  { id: 61, 
    title: "Dedicate Level 1 IT support and Oncall and Schedule remote management of the total IT infrastructure of the client", 
    category: 'itops', 
    image: '', 
    sub_category: "Operations and Management",
    objectives: "Total management of the entire IT infrastructure to relieve the client to focus on the business.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Total management and administration",

    technology_stack:pragictslogo,
 
  
    technology_name:"Technology Stacks pertaining to ITOps, CloudOps, Automation, Unified Management, SecOps, etc.",

  

    technology_stack_link:"#",
   



    engineering:'Total Management including procurement',
    online_reference:''
  },
  { id: 62, 
    title: "Endpoint Detection And Response (EDR) security", 
    category: ['itops','cyber'] ,
    image: '', 
    sub_category: "Security",
    objectives: "Comprehensive security at both macro and micro levels", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Procurement, Installation, Configuration and Management",

    technology_stack:bitdefender,
 
  
    technology_name:"bitdefender",

  

    technology_stack_link:"https://www.bitdefender.com/en-us/business/gravityzone-platform/",
   



    engineering:'Total Management including procurement',
    online_reference:''
  },
  { id: 63, 
    title: "Cost optimization of firewall infrastructure both at the appliance and license level ", 
    category: 'itops' ,
    image: '', 
    sub_category: "Security",
    objectives: "Cost optimization through the deployment of a centralized firewall fabric with availability and cloud management through Palo Alto Enterprise grade firewall and software.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Applied research and development, solution proposition, POC implementation, procurement, installation, configuration, policy definition and implementation, management and support.",

    technology_stack:paloalto,
 
  
    technology_name:"Palo Alto",

  

    technology_stack_link:"https://www.paloaltonetworks.com/",
   



    engineering:'Applied R&D across (Fortinet, CheckPoint and Palo Alto) to test for solution scope.',
    online_reference:''
  },
  { id: 64, 
    title: "Upgrade of rack server upgrade with failover on Window Server 2022 with domain configuration", 
    category: 'itops' ,
    image: '', 
    sub_category: "On Premise Server Infrastructure",
    objectives: "Upgrade the on premise server infrastructure for seamless it operations", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Assessment of rack server infrastructure, finalization, procurement, installation, configuration, management and support.",

    technology_stack:dell,
    technology_stack2:microsoft,
    technology_stack3:abb,
  
    technology_name:"Dell",
    technology_name2:"Microsoft",
    technology_name3:"ABB",

    technology_stack_link:"https://www.dell.com/en-us/shop/scc/sc/servers",
    technology_stack2_link:"https://www.microsoft.com/en-us/evalcenter/evaluate-windows-server-2022",
    technology_stack3_link:"https://new.abb.com/ups/systems",



    engineering:'Evaluation of rack servers, cohesive implementation and integration.',
    online_reference:''
  },
  { id: 65, 
    title: "Firewall infrastructure upgrade to enterprise grade infrastructure", 
    category: ['itops','cyber'] ,
    image: '', 
    sub_category: "Security",
    objectives: "Enhance security including firewall performance, scalability and end of life duration and firewall cost reduction.", 
    client:"Grown from a small company to a medium enterprise in the tourism sector.",
    key_functions:"Applied research and development, solution proposition, POC implementation, procurement, installation, configuration, policy definition and implementation, management and support.",

    technology_stack:checkpoint,
 
  
    technology_name:"Check Point",
  

    technology_stack_link:"https://www.checkpoint.com/",
 



    engineering:'Migrated from Forninet to Checkpoint enterprise grade firewall with better end-of-appliance duration, features, performance and cost of ownership',
    online_reference:''
  },
  { id: 66, 
    title: "ISP redundancy and policy management for Internet performance, scalability and availability through firewall setup and configuration of policies for traffic management and performance", 
    category: 'itops' ,
    image: '', 
    sub_category: "Internet",
    objectives: "Internet availability and performance is critical to business operations 24X7", 
    client:"Medium enterprise grade client with heavy investment of IT for business performance and throughput.",
    key_functions:"Refactoring of ISP connections to Fiber based connectivity. Setup and configuration of the firewall for redundancy, load balancing and throughput with policies, monitoring and management of policies for optimization for quality and consistency of performance based on usage trends",

    technology_stack:checkpoint,
 
  
    technology_name:"Check Point",
  

    technology_stack_link:"https://www.checkpoint.com/",
 



    engineering:'Study of usage trends, priorities and user groups for firewall policy design and implementation.',
    online_reference:''
  },
  { id: 67, 
    title: "Upgrade of wireless networking infrastructure with enterprise grade WAPs for throughput and scalability", 
    category: 'itops' ,
    image: '', 
    sub_category: "Wireless Networking",
    objectives: "Enhance the end to end throughput of the wireless networking infrastructure for endpoint devices", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Evaluation and assessment of options, POC, implementation, configuration and management",

    technology_stack:extreme,
 
  
    technology_name:"Extreme Networks",
  

    technology_stack_link:"https://www.extremenetworks.com/",
 



    engineering:'Location assessment, signal range coverage and strength, quality testing of the wired network cables, installation of the WAP, configuration of policies and integration with the firewall and switch infrastructure.',
    online_reference:''
  },
  { id: 68, 
    title: "Upgrade of wireless networking infrastructure with enterprise grade WAPs for throughput and scalability", 
    category: 'itops' ,
    image: '', 
    sub_category: "Wireless Networking",
    objectives: "Enhance the end to end throughput of the wireless networking infrastructure for endpoint devices", 
    client:"Medium enterprise grade client with multiple locations",
    key_functions:"Evaluation and assessment of options, POC, implementation, configuration and management",

    technology_stack:hp,
 
  
    technology_name:"Aruba Networks ",
  

    technology_stack_link:"https://www.arubanetworks.com/ ",
 



    engineering:'Location assessment, signal range coverage and strength, quality testing of the wired network cables, installation of the WAP, configuration of policies and integration with the firewall and switch infrastructure.',
    online_reference:''
  },
  { id: 69, 
    title: "Upgrade of switches to enterprise grade with managed functionality for enhancing end to end throughput", 
    category: 'itops' ,
    image: '', 
    sub_category: "Networking",
    objectives: "Enhance the end to end throughput of the entire network from the ISP to the firewalls, to the servers to the switches, to the WAPs to the end computing devices", 
    client:"Medium enterprise grade client with multiple locations",
    key_functions:"Evaluation and assessment of options, POC, implementation, configuration and management",

    technology_stack:extreme,
 
  
    technology_name:"Extreme Networks",
  

    technology_stack_link:"https://www.extremenetworks.com/ ",
 



    engineering:'Configuration and setup of the switches for cohesive integration.',
    online_reference:''
  },
  { id: 70, 
    title: "Upgrade of switches to enterprise grade with managed functionality for enhancing end to end throughput", 
    category: 'itops' ,
    image: '', 
    sub_category: "Networking",
    objectives: "Enhance the end to end throughput of the entire network from the ISP to the firewalls, to the servers to the switches, to the WAPs to the end computing devices", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"Evaluation and assessment of options, POC, implementation, configuration and management",

    technology_stack:extreme,
 
  
    technology_name:"Extreme Networks",
  

    technology_stack_link:"https://www.extremenetworks.com/ ",
 



    engineering:'Configuration and setup of the switches for cohesive integration.',
    online_reference:''
  },
  { id: 71, 
    title: "Commissioning for cloud infrastructure for the migration of on premise server ERP applications to the cloud for application.", 
    category: ['itops','cloudops'] ,
    image: '', 
    sub_category: "Cloud Provisioning (Microsoft Azure)",
    objectives: "Cost optimization, reliability, availability, scalability and access of core applications of the business.", 
    client:"Medium enterprise grade client with multiple locations",
    key_functions:"Evaluation of Cloud infrastructure options, security configurations, POC, implementation and management",

    technology_stack:azure ,
 
  
    technology_name:"Azure ",
  

    technology_stack_link:"https://azure.microsoft.com/en-us/",
 



    engineering:'Configuration of security to ensure that applications are accessible on the cloud through the firewall with permenent binding between the firewall and cloud infrastructure including automated backup. Cloud infrastructure is commissioned with the closest data center for performance and throughput.',
    online_reference:''
  },
  { id: 72, 
    title: "Commissioning for cloud infrastructure for the ecommerce platform.", 
    category: ['itops','cloudops'] ,
    image: '', 
    sub_category: "Cloud Provisioning (Microsoft AWS)",
    objectives: "eCommerce platform with top tier security, performance, scalability and availability", 
    client:"Large enterprise grade client.",
    key_functions:"Evaluation of cloud infrastructure options, POC, implementation and management",

    technology_stack:aws,
    technology_stack2:redis,
    technology_stack3:cloudfront,
    technology_stack4:cloudflare,
    technology_stack5:mysql,
    technology_stack6:ec2,
  
    technology_name:"AWS",
    technology_name2:"Redis",
    technology_name3:"Cloudfront",
    technology_name4:"Cloudflare",
    technology_name5:"Mysql",
    technology_name6:"EC2",

    technology_stack_link:"https://aws.amazon.com/",
    technology_stack2_link:"https://redis.io/",
    technology_stack3_link:"https://aws.amazon.com/cloudfront/",
    technology_stack4_link:"https://www.cloudflare.com/",
    technology_stack5_link:"https://www.mysql.com/",
    technology_stack6_link:"https://aws.amazon.com/ec2",


    engineering:'AWS infrastructure with proximity based configuration for scalability, security, performance and availability.',
    online_reference:''
  },
  { id: 73, 
    title: "Transition to cloud storage from on-prem storage with backup and availability options.", 
    category: ['itops','cloudops'] ,
    image: '', 
    sub_category: "Cloud Storage (Microsoft Azure)",
    objectives: "Move from local storage option to centralized cloud storage option with security, backup and availability. Prevent options for on-prem storage of company documents,", 
    client:"Large enterprise grade client.",
    key_functions:"Evaluation of Cloud infrastructure options, security configurations, POC, implementation and management",

    technology_stack:azure,
 
  
    technology_name:"Microsoft Azure",
  

    technology_stack_link:"https://azure.microsoft.com/en-us/",
 



    engineering:'Provisioning for Microsoft Azure Infrastructure with configurations for effective and secure storage access with policies.',
    online_reference:''
  },
  { id: 74, 
    title: "Migration of corporate mail infrastructure from Google Workspace to Microsoft Office 365 with mail account migration. ", 
    category: ['itops','cloudops'] ,
    image: '', 
    sub_category: "Microsoft Office 365",
    objectives: "Move to Microsoft Office 365 for better integration with office products, cost optimization and seamless operation.", 
    client:"Large enterprise grade client with multiple locations",
    key_functions:"POC, Implementation, Configuration, Migration, support and management ",

    technology_stack:microsoft,
    technology_stack2:workspace,
 
  
    technology_name:"Microsoft 365",
    technology_name2:"Google Workspace",
  

    technology_stack_link:"https://www.microsoft.com/en-sg/microsoft-365",
    technology_stack2_link:"https://workspace.google.com/intl/en_sg/",



    engineering:'Configuration of Office 365 with Mail account migration.',
    online_reference:''
  },
  { id: 75, 
    title: "Implementation and management of Google Workspace as the corporate communication platform.", 
    category: ['itops','cloudops'] ,
    image: '', 
    sub_category: "Google Workplace",
    objectives: "Effective platform for communication with client across the world including staff and stakeholder communication.", 
    client:"Medium enterprise grade client with multiple locations",
    key_functions:"Implementation, Configuration, Support and Management  of Google Workspace.",

    technology_stack:google,
 
  
    technology_name:"Google Workspace",
  

    technology_stack_link:"https://workspace.google.com/",
 



    engineering:'Setup of Google Workspace',
    online_reference:''
  },
  { id: 76, 
    title: "Cloud and Onprem hard binding through VPN tunnelling for secure access", 
    category: ['itops','cyber'] ,
    image: '', 
    sub_category: "Security",
    objectives: "Secure the cloud infrastructure and make it accessible through the onprem network", 
    client:"Medium enterprise",
    key_functions:"Applied research and development, solution proposition, POC implementation, procurement, installation, configuration, policy definition and implementation, management and support.",

    technology_stack:checkpoint,
    technology_stack2:azure,
  
    technology_name:"Check Point",
    technology_name2:"Azure",
  

    technology_stack_link:"https://www.checkpoint.com/",
    technology_stack2_link:"https://azure.microsoft.com/en-us/",



    engineering:'Hard binding of the cloud infrastructure to the firewall',
    online_reference:''
  },
];



const Projects = () => {
  const [filteredCategory, setFilteredCategory] = useState('All');
  const [expandedProjectId, setExpandedProjectId] = useState(null);

  // Read URL parameter when the component mounts
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const category = queryParams.get('category');
    if (category) {
      setFilteredCategory(category);
    }
  }, []); // Empty dependency array ensures this runs only once on component mount

  // Handle category filter change
  const handleFilter = (category) => {
    setFilteredCategory(category);
    // Update the URL without reloading the page
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('category', category);
    window.history.pushState(null, '', currentUrl.toString());
  };

  // Toggle the expanded state for project details
  const toggleExpand = (id) => {
    setExpandedProjectId(expandedProjectId === id ? null : id);
  };

  // Filter the projects based on the selected category
  const filteredProjects = filteredCategory === 'All'
    ? projects
    : projects.filter(project => project.category.includes(filteredCategory));


  return (
    <section data-scrollax-parent="true" id="projects">
      <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
        <span>//</span>Projects
      </div>

      <section data-scrollax-parent="true" id="sec1" style={{ padding: '50px 0' }}>
        <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
          <span>//</span>Featured Projects
        </div>
        <div className="container main-about">

          <p style={{ fontSize: '14px' }}>
            Below are some of our featured projects, showcasing the diverse engineering solutions we've delivered across our service verticals. 
            This compilation highlights the work we've executed on behalf of our clients, driving their digital transformation journey towards business success. 
            From enhancing digital presence, developing software solutions, and optimizing cloud infrastructure, to advancing on-premise setups, automation, AI, security, and more.
          </p>
          <p style={{ fontSize: '14px', paddingBottom: '50px' }}>
            These projects reflect our commitment to expanding the scope and impact of digital innovation.
          </p>

          {/* Filter options */}
          <div className="portfolio-filter">
            <span onClick={() => handleFilter('All')} className={filteredCategory === 'All' ? 'active' : ''}>
              All
            </span>
            <span onClick={() => handleFilter('software')} className={filteredCategory === 'software' ? 'active' : ''}>
              Software Development
            </span>
            <span onClick={() => handleFilter('ecommerce')} className={filteredCategory === 'ecommerce' ? 'active' : ''}>
              eCommerce
            </span>
            <span onClick={() => handleFilter('itops')} className={filteredCategory === 'itops' ? 'active' : ''}>
              ITOps
            </span>
            <span onClick={() => handleFilter('cloudops')} className={filteredCategory === 'cloudops' ? 'active' : ''}>
              CloudOps
            </span>
            <span onClick={() => handleFilter('automation')} className={filteredCategory === 'automation' ? 'active' : ''}>
              Automation
            </span>
            <span onClick={() => handleFilter('cyber')} className={filteredCategory === 'cyber' ? 'active' : ''}>
              CyberSecOps
            </span>
          </div>

          <div className="portfolio-grid-wrapper" style={{ marginTop: '30px' }}>
            <div className="portfolio-grid">
              {filteredProjects.map(project => (
                <div key={project.id} className="portfolio-item">
                  <div className="portfolio-img">
                    {project.image ? (<img src={project.image} alt={project.title} />) : null}
                  </div>
                  <div className="portfolio-details">
                    <p style={{ fontSize: '10px', textTransform: 'uppercase' }}>{project.sub_category}</p>
                    <h4 style={{ fontSize: '18px', textTransform: 'uppercase', paddingBottom: '20px' }}>{project.title}</h4>
                    <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'left' }}>
                      <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Technology Stack</span>
                      <br />
                      <span style={{ display: 'flex', gap: '5px', paddingTop: '10px' }}>
                        {project.technology_stack_link ? (
                          <a href={project.technology_stack_link} target='_blank'>
                            <img src={project.technology_stack} alt="tech stack 1" title={project.technology_name} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack2_link ? (
                          <a href={project.technology_stack2_link} target='_blank'>
                            <img src={project.technology_stack2} alt="tech stack 2" title={project.technology_name2} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack3_link ? (
                          <a href={project.technology_stack3_link} target='_blank'>
                            <img src={project.technology_stack3} alt="tech stack 3" title={project.technology_name3} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack4_link ? (
                          <a href={project.technology_stack4_link} target='_blank'>
                            <img src={project.technology_stack4} alt="tech stack 4" title={project.technology_name4} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack5_link ? (
                          <a href={project.technology_stack5_link} target='_blank'>
                            <img src={project.technology_stack5} alt="tech stack 5" title={project.technology_name5} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack6_link ? (
                          <a href={project.technology_stack6_link} target='_blank'>
                            <img src={project.technology_stack6} alt="tech stack 6" title={project.technology_name6} className='techstack' />
                          </a>
                        ) : null}
                        {project.technology_stack7_link ? (
                          <a href={project.technology_stack7_link} target='_blank'>
                            <img src={project.technology_stack7} alt="tech stack 7" title={project.technology_name7} className='techstack' />
                          </a>
                        ) : null}
                      </span>
                    </p>

                    {/* When expanded, show all details */}
                    {expandedProjectId === project.id && (
                      <>
                        <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'justify' }}>
                          <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Client Objectives<br /> </span>
                          {project.objectives}
                        </p>
                        <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'left' }}>
                          <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Client<br /></span>
                          {project.client}
                        </p>
                        <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'left' }}>
                          <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Key Functions<br /></span>
                          {project.key_functions}
                        </p>
                        <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'left' }}>
                          <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Engineering<br /></span>
                          {project.engineering}
                        </p>

                        {project.online_reference && (
                          <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'left' }}>
                            <span style={{ textTransform: 'uppercase', color: 'black', fontWeight: 'bold' }}>Online Reference<br /></span>
                            <a href={project.online_reference} target='_blank' className='project_link'>Visit Site</a>
                          </p>
                        )}
                      </>
                    )}

                    {/* Expand/Shrink functionality */}
                    <button onClick={() => toggleExpand(project.id)} style={{ marginTop: '10px', backgroundColor: 'red', padding: '5px 10px' }}>
                      {expandedProjectId === project.id ? 'Collapse' : 'Expand'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="bg-parallax-module" data-position-top="50" data-position-left="20" data-scrollax="properties: { translateY: '-250px' }"></div>
      <div className="bg-parallax-module" data-position-top="40" data-position-left="70" data-scrollax="properties: { translateY: '150px' }"></div>
      <div className="bg-parallax-module" data-position-top="80" data-position-left="80" data-scrollax="properties: { translateY: '350px' }"></div>
      <div className="bg-parallax-module" data-position-top="95" data-position-left="40" data-scrollax="properties: { translateY: '-550px' }"></div>
      <div className="sec-lines"></div>
    </section>
  );
};

export default Projects;

